{
  "Account not linked": "Compte non relié",
  "Account not linked to a Boond person": "Compte non relié à une personne Boond",
  "Add a person…": "Ajouter une personne…",
  "Add a technology (Enter to confirm)": "Ajouter une technologie (Entrée pour valider)",
  "An unexpected error occurred.": "Une erreur inattendue est survenue.",
  "Assignment not created": "Affectation non créée",
  "Assignment not ended": "Affectation non terminée",
  "Cancel": "Annuler",
  "Could not load": "Chargement impossible",
  "Could not open your session": "Impossible d'ouvrir votre session",
  "Could not refresh": "Actualisation impossible",
  "DAR list not saved": "Liste DAR non enregistrée",
  "Decision not saved": "Décision non enregistrée",
  "Enter to add « {{name}} »": "Entrée pour ajouter « {{name}} »",
  "Error {{line}}": "Erreur {{line}}",
  "Git identities not saved": "Identités Git non enregistrées",
  "Links not saved": "Liens non enregistrés",
  "Loading…": "Chargement…",
  "No person found": "Aucune personne trouvée",
  "No suggestions": "Aucune suggestion",
  "Nobody yet.": "Personne pour l'instant.",
  "Not filled in": "Non renseigné",
  "Opening your session…": "Ouverture de votre session…",
  "Override not saved": "Forçage non enregistré",
  "Project not created": "Projet non créé",
  "Project not updated": "Projet non modifié",
  "Reminder not sent": "Relance non envoyée",
  "Remove {{name}}": "Retirer {{name}}",
  "Report not saved": "CRA non enregistré",
  "Request not cancelled": "Demande non annulée",
  "Request not sent": "Demande non envoyée",
  "Restricted to the DAR": "Accès réservé à la DAR",
  "Retry": "Réessayer",
  "Rule not saved": "Règle non enregistrée",
  "Search for a person…": "Rechercher une personne…",
  "Searching…": "Recherche…",
  "Server unreachable: check your connection.": "Serveur injoignable : vérifiez votre connexion.",
  "Session expired: signing in again.": "Session expirée : reconnexion en cours.",
  "Settings not saved": "Paramètres non enregistrés",
  "Status not changed": "Statut non modifié",
  "Stream not archived": "Stream non archivé",
  "Stream not created": "Stream non créé",
  "Stream not updated": "Stream non modifié",
  "Submitted on {{date}}": "Soumis le {{date}}",
  "Sync not requested": "Synchronisation non demandée",
  "TL/PO not saved": "TL/PO non enregistrés",
  "TRL {{trl}} of 9: {{text}}": "TRL {{trl}} sur 9 : {{text}}",
  "Technologies": "Technologies",
  "The action failed": "L'action n'a pas abouti",
  "These screens belong to the resource allocation office.": "Ces écrans sont ceux de la direction de l'allocation des ressources.",
  "Your DAR account is not linked to any Boond person: this page is about the people assigned to projects. Link your account from Administration › People.": "Votre compte DAR n'est relié à aucune personne Boond : cette page concerne les personnes affectées aux projets. Reliez votre compte depuis Administration › Personnes.",
  "not assignable": "non assignable",
  "{{count}} reports_one": "{{count}} compte rendu",
  "{{count}} reports_other": "{{count}} comptes rendus",
  "{{label}}: add a person": "{{label}} : ajouter une personne"
}
